var React = require('react');

function Contact (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M22 1H2v0C.89 1 0 1.89 0 3v13.552 0c0 1.07.87 1.95 1.95 1.94 .01-.01.02-.01.04-.01h2.5v3.5 0c-.01.55.44 1 .99 1 .2 0 .4-.07.56-.18l6.24-4.323h9.68v0c1.1 0 2-.9 2-2V2.97v0c0-1.11-.9-2-2-2Zm0 15.25v0c0 .13-.12.25-.25.25H12v-.001c-.21 0-.41.06-.57.17l-4.94 3.41v-2.6 0c0-.56-.45-1-1-1H2.24v0c-.14 0-.25-.12-.25-.25v-13 0c0-.14.11-.25.25-.25h19.5v0c.13 0 .25.11.25.25Z","key":0}),React.createElement("path",{"d":"M6 8.5h12v0c.55 0 1-.45 1-1 0-.56-.45-1-1-1H6v0c-.56 0-1 .44-1 1 0 .55.44 1 1 1Z","key":1}),React.createElement("path",{"d":"M6 13h12v0c.55 0 1-.45 1-1 0-.56-.45-1-1-1H6v0c-.56 0-1 .44-1 1 0 .55.44 1 1 1Z","key":2})]));
}

Contact.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Contact;

Contact.default = Contact;
